import { createContext, useContext } from 'react'

import defaultTheme from '@/themes/defaultTheme'

import type { Theme } from '@/themes/types'
import type { ReactNode } from 'react'

const ThemeContext = createContext<Theme>(defaultTheme)

interface ThemeProviderProps {
  theme?: Theme
  children: ReactNode
}

export const ThemeProvider = ({ theme = defaultTheme, children }: ThemeProviderProps) => (
  <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
)

export const useTheme = () => useContext(ThemeContext)
